import request from '@/utils/request'

// 获取我的下线代理数量
export function getAgentDownNumber(params) {
  return request({
    url: '/api/useragent.my_agent/player_stat',
    method: 'get',
    params
  })
}

// 获取我的代理信息
export function getMyAgentInfo(params) {
  return request({
    url: '/api/useragent.my_agent/profile',
    method: 'get',
    params
  })
}

// 获取邀请链接
export function getInviteUrl(params) {
  return request({
    url: '/api/useragent.my_agent/invite_url',
    method: 'get',
    params
  })
}

// 获取我邀请的音乐人
export function getInviteList(params) {
  return request({
    url: '/api/user/register',
    method: 'get',
    params
  })
}

// 获取我的绑卡信息
export function getAgentBankInfo(params) {
  return request({
    url: '/api/useragent.my_agent/card_info',
    method: 'get',
    params
  })
}

// 绑定代理银行卡
export function bindAgentBank(data) {
  return request({
    url: '/api/useragent.my_agent/bind_card',
    method: 'post',
    data
  })
}

// 提现接口
export function agentWithdraw(data) {
  return request({
    url: '/api/useragent.cash/draw',
    method: 'post',
    data
  })
}


// 提现接口
export function agentWithdrawRecord(data) {
  return request({
    url: '/api/useragent.cash/draw_list',
    method: 'post',
    data
  })
}

// 获取生成代理页面的个人性质接口
export function getGenerateAgentProperty(data) {
  return request({
    url: '/api/useragent.register/getproperty',
    method: 'post',
    data
  })
}

// 验证生成代理
export function checkGenerateAgent(data) {
  return request({
    url: '/api/useragent.register/check_info',
    method: 'post',
    data
  })
}

// 验证生成代理
export function generateAgentQr(data) {
  return request({
    url: '/api/useragent.register/reg_add',
    method: 'post',
    data
  })
}

// 验证生成代理
export function getReglist(data) {
  return request({
    url: '/api/useragent.register/getreglist',
    method: 'post',
    data
  })
}

// 延长过期时间
export function refreshLink(data) {
  return request({
    url: '/api/useragent.register/recovery',
    method: 'post',
    data
  })
}

// 获取直属音乐人列表
export function getMusicPerson(params) {
  return request({
    url: '/api/useragent.my_agent/player_list',
    method: 'get',
    params
  })
}

// 获取直属音代理人列表
export function getAgentMuiscPerson(params) {
  return request({
    url: '/api/useragent.my_agent/agent_list',
    method: 'get',
    params
  })
}

// 获取代理合作协议链接接口
export function getAgentSign(params) {
  return request({
    url: '/api/useragent.contract/sign',
    method: 'get',
    params
  })
}

// 获取代理实名签约合作协议链接接口
export function getAgentIdentity(params) {
  return request({
    url: '/api/useragent.my_agent/identity',
    method: 'get',
    params
  })
}

// 获取代理账单核对---直属音乐人账单
export function getAgentBillMusic(data) {
  return request({
    url: '/api/useragent.cash/bill_list',
    method: 'post',
    data
  })
}

// 获取代理账单核对---直属代理账单
export function getAgentBill(data) {
  return request({
    url: '/api/useragent.cash/agent_bill',
    method: 'post',
    data
  })
}

// 获取代理账单核对---直属代理人详情
export function getAgentBillInfo(data) {
  return request({
    url: '/api/useragent.cash/agent_bill_info',
    method: 'post',
    data
  })
}

// 获取代理首页数据
export function getAgentHomeData(params) {
  return request({
    url: '/api/app.aguser/get_index_data',
    method: 'post',
    params
  })
}

// 代理分享计数
export function shareCount(params) {
  return request({
    url: '/api/useragent.my_agent/shareposters',
    method: 'get',
    params
  })
}
